<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">角色管理</div>
          <span class="m-title-s">对系统内角色进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>系统角色列表
          </div>
          <div class="m-table-btn">
            <el-button @click="addRole" type="primary">新增角色</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="name" label="角色名称" width="220"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="60">
            <template slot-scope="scope">
              <span v-text="scope.row.status === '1' ? '启用' : '禁用'"></span>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="更新时间" width="110" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id, scope.row.name)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="form.id" type="hidden"></el-input>
            </el-form-item>
            <el-form-item label="角色名称: " prop="name">
              <el-input v-model="form.name" placeholder="输入角色名称"></el-input>
            </el-form-item>
            <el-form-item label="授权角色功能">
              <el-card shadow="hover">
                <el-tree
                  :data="powerList"
                  show-checkbox
                  :check-strictly="true"
                  node-key="id"
                  :filter-node-method="filterNode2"
                  :props="defaultProps"
                  ref="powerTree">
                </el-tree>
              </el-card>
            </el-form-item>
            <el-form-item label="设置状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
            <el-form-item label="备注说明: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RoleManage',
  data () {
    return {
      openText: '新增',
      openState: false,
      tree: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      filterText: '',
      list: [],
      powerList: [],
      powerNum: '',
      form: {
        id: '',
        name: '',
        status: '1',
        menuIds: [],
        remarks: ''
      },
      defaultProps: {
        children: 'children',
        label: 'title',
        isLeaf: false
      },
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 权限选中项
    handleCheckChange (data, checked, indeterminate) {
      console.log(data.id)
      // console.log(checked)
      // console.log(indeterminate)
    },
    filterNode2 (value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    closeDialog: function () {
      this.form = {
        id: '',
        name: '',
        status: '1',
        menuIds: [],
        remarks: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
      this.$refs.powerTree.setCheckedKeys([])
    },
    addRole () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          _this.form.menuIds = _this.$refs.powerTree.getCheckedKeys()
          if (_this.form.menuIds.length === 0) {
            _this.$message.error('您还未分配权限！')
            _this.formLoading = false
            return
          }
          _this.form.status = _this.isStatus === true ? '1' : '0'
          let url = _this.form.id === '' ? '/sys/role/add' : '/sys/role/update'
          this.$axios.post(url, _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id, title) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除[' + title + '], 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/admin/roleDel', {id: id})
          .then((res) => {
            if (res.code === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    openForm (id) {
      let _this = this
      _this.openText = '编辑'
      _this.openState = true
      _this.formLoading = true
      this.$axios.post('/sys/role/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            _this.form = res.data
            _this.isLoading = false
            // 判断开启状态，1：开启，0:关闭
            _this.isStatus = _this.form.status === '1'
            _this.formLoading = false
            _this.$nextTick(() => {
              _this.$refs.powerTree.setCheckedNodes(res.data.menuList)
            })
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 角色列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/sys/role/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    },
    // 权限树
    powerListData () {
      let _this = this
      this.isLoading = true
      _this.powerList = []
      this.$axios.post('/sys/menu/pullDownList')
        .then((res) => {
          _this.powerList = res.data
        })
    }
  },
  mounted () {
    this.listData()
    this.powerListData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sys/RoleManage.vue